let ctx: AudioContext | null = null;
let globalVolume = 0.5;

function getStoredVolume(): number {
  try {
    const v = localStorage.getItem("sw_volume");
    if (v !== null) return Math.max(0, Math.min(1, parseFloat(v)));
  } catch {}
  return 0.5;
}

globalVolume = getStoredVolume();

export function getVolume(): number {
  return globalVolume;
}

export function setVolume(v: number): void {
  globalVolume = Math.max(0, Math.min(1, v));
  try {
    localStorage.setItem("sw_volume", String(globalVolume));
  } catch {}
}

function getCtx(): AudioContext {
  if (!ctx) ctx = new AudioContext();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function playTone(
  freq: number,
  duration: number,
  type: OscillatorType = "square",
  volume = 0.1
) {
  if (globalVolume <= 0) return;
  const c = getCtx();
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.value = volume * globalVolume;
  gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + duration);
  osc.connect(gain);
  gain.connect(c.destination);
  osc.start(c.currentTime);
  osc.stop(c.currentTime + duration);
}

function playNoise(duration: number, volume = 0.05) {
  if (globalVolume <= 0) return;
  const c = getCtx();
  const bufferSize = c.sampleRate * duration;
  const buffer = c.createBuffer(1, bufferSize, c.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) data[i] = Math.random() * 2 - 1;
  const source = c.createBufferSource();
  source.buffer = buffer;
  const gain = c.createGain();
  gain.gain.value = volume * globalVolume;
  gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + duration);
  source.connect(gain);
  gain.connect(c.destination);
  source.start();
}

export const sfx = {
  tilePickup: () => playTone(523, 0.08, "square"),
  tilePlace: () => playTone(392, 0.06, "square"),
  invalid: () => playNoise(0.1),
  timerWarning: () => playTone(880, 0.05, "square", 0.15),
  reveal: () => {
    playTone(523, 0.1, "square");
    setTimeout(() => playTone(659, 0.1, "square"), 100);
    setTimeout(() => playTone(784, 0.15, "square"), 200);
  },
  victory: () => {
    playTone(523, 0.15, "square");
    setTimeout(() => playTone(659, 0.15, "square"), 150);
    setTimeout(() => playTone(784, 0.15, "square"), 300);
    setTimeout(() => playTone(1047, 0.3, "triangle"), 450);
  },
};
